import { FC } from "react";
import EmojiPicker, { EmojiClickData } from "emoji-picker-react";
import { UseDisclosureReturn } from "@chakra-ui/react";

type AppEmojiPickerProps = {
    emojiState: UseDisclosureReturn;
    onEmojiClick: (e: EmojiClickData) => void;
};

export const AppEmojiPicker: FC<AppEmojiPickerProps> = ({
    emojiState,
    onEmojiClick,
}) => {
    // const pickerRef = useRef<HTMLDivElement | null>(null);

    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         if (
    //             pickerRef.current &&
    //             !pickerRef.current.contains(event.target as Node)
    //         ) {
    //             emojiState.onClose();
    //         }
    //     };

    //     if (emojiState.isOpen) {
    //         document.addEventListener("mousedown", handleClickOutside);
    //     }

    //     return () => {
    //         document.removeEventListener("mousedown", handleClickOutside);
    //     };
    // }, [emojiState.isOpen]);

    return (
        <>
            {emojiState.isOpen && (
                <div
                    // ref={pickerRef}
                    style={{
                        position: "absolute",
                        bottom: "48px",
                        right: "1.5rem",
                        zIndex: 1000,
                    }}
                >
                    <EmojiPicker
                        searchDisabled={true}
                        skinTonesDisabled={true}
                        // previewConfig={{ showPreview: false }}
                        onEmojiClick={onEmojiClick}
                    />
                </div>
            )}
        </>
    );
};
